import { render, staticRenderFns } from "./BatchAnkiModalBody.vue?vue&type=template&id=5d400a99&lang=pug&"
import script from "./BatchAnkiModalBody.vue?vue&type=script&lang=js&"
export * from "./BatchAnkiModalBody.vue?vue&type=script&lang=js&"
import style0 from "./BatchAnkiModalBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports